// Google OAuth 2.0 — Authorization Code flow (sans Emergent).
// Le client_id est récupéré dynamiquement depuis le backend (/auth/google/config)
// pour ne pas le hardcoder. La redirection vers Google se fait côté navigateur.

import { api } from "../lib/api";

const GOOGLE_AUTH_URL = "https://accounts.google.com/o/oauth2/v2/auth";

export function getGoogleRedirectUri() {
  return window.location.origin + "/auth/callback";
}

// Récupère la config Google (client_id + enabled) depuis le backend.
// Mise en cache module-level pour éviter des appels répétés.
let _configCache = null;
export async function getGoogleConfig() {
  if (_configCache) return _configCache;
  try {
    const { data } = await api.get("/auth/google/config");
    _configCache = data;
    return data;
  } catch (e) {
    return { enabled: false, client_id: "" };
  }
}

// Lance la redirection vers Google. À appeler sur clic du bouton "Continuer avec Google".
export async function startGoogleLogin() {
  const cfg = await getGoogleConfig();
  if (!cfg.enabled || !cfg.client_id) {
    throw new Error("Google login non configuré");
  }
  const params = new URLSearchParams({
    client_id: cfg.client_id,
    redirect_uri: getGoogleRedirectUri(),
    response_type: "code",
    scope: "openid email profile",
    access_type: "online",
    prompt: "select_account",
  });
  window.location.href = `${GOOGLE_AUTH_URL}?${params.toString()}`;
}
